var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1019_131274)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.94727,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#29B719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 52.5723H26.5C26.1611 52.5723 25.875 52.2861 25.875 51.9473C25.875 51.6084 26.1611 51.3223 26.5 51.3223H53.5C53.8389 51.3223 54.125 51.6084 54.125 51.9473C54.125 52.2861 53.8389 52.5723 53.5 52.5723Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 48.5726H28C26.56 48.5726 25.375 47.3876 25.375 45.9476V33.0176C25.375 31.5776 26.56 30.3926 28 30.3926H30.4C31.84 30.3926 33.025 31.5776 33.025 33.0176V45.9476C33.025 47.3876 31.84 48.5726 30.4 48.5726ZM28 32.6276C27.79 32.6276 27.625 32.7926 27.625 33.0026V45.9476C27.625 46.1576 27.79 46.3226 28 46.3226H30.4C30.61 46.3226 30.775 46.1576 30.775 45.9476V33.0176C30.775 32.8076 30.61 32.6426 30.4 32.6426H28V32.6276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1968 48.5724H38.7969C37.3569 48.5724 36.1719 47.3874 36.1719 45.9474V28.2324C36.1719 26.7924 37.3569 25.6074 38.7969 25.6074H41.1968C42.6368 25.6074 43.8218 26.7924 43.8218 28.2324V45.9474C43.8218 47.3874 42.6368 48.5724 41.1968 48.5724ZM38.7969 27.8574C38.5869 27.8574 38.4219 28.0224 38.4219 28.2324V45.9474C38.4219 46.1574 38.5869 46.3224 38.7969 46.3224H41.1968C41.4068 46.3224 41.5718 46.1574 41.5718 45.9474V28.2324C41.5718 28.0224 41.4068 27.8574 41.1968 27.8574H38.7969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0015 48.5723H49.6016C48.1616 48.5723 46.9766 47.3873 46.9766 45.9473V23.4473C46.9766 22.0073 48.1616 20.8223 49.6016 20.8223H52.0015C53.4415 20.8223 54.6265 22.0073 54.6265 23.4473V45.9473C54.6265 47.3873 53.4415 48.5723 52.0015 48.5723ZM49.6016 23.0723C49.3916 23.0723 49.2266 23.2373 49.2266 23.4473V45.9473C49.2266 46.1573 49.3916 46.3223 49.6016 46.3223H52.0015C52.2115 46.3223 52.3765 46.1573 52.3765 45.9473V23.4473C52.3765 23.2373 52.2115 23.0723 52.0015 23.0723H49.6016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1019_131274",
    x: 0,
    y: 0.947266,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1019_131274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1019_131274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.9699d214c17ae27fc6a11aa73d070604.svg";
export { ForwardRef as ReactComponent };